<template>
  <div class="tw-h-full tw-w-full tw-shadow">
    <b-card no-body class="tw-h-full tw-w-full tw-p-0 tw-m-0" v-if="ready">
      <b-tabs v-model="tabIndex" card fill>
        <b-tab v-for="(tab, key) in tabs" :title="key" :key="key" :active="key === defaultSelected">
          <h6 class="tw-font-bolder tw-mb-0">Followups Completed on Time</h6>
          <p class="text-secondary tw-text-xs">Out of total scheduled for Baseline</p>
          <b-nav pills align="center" class="tw-text-xs">
            <b-nav-item :active="view == 'total'" @click="view = 'total'">All</b-nav-item>
            <b-nav-item :active="view == 'clinic'" @click="view = 'clinic'">Clinic</b-nav-item>
            <b-nav-item :active="view == 'compound'" @click="view = 'compound'">Compound</b-nav-item>
          </b-nav>
          <doughnut-chart class="shift-pills" v-show="view === 'total'" :chartdata="tab.totalChartdata" :options="tab.options"></doughnut-chart>
          <doughnut-chart class="shift-pills" v-show="view === 'clinic'" :chartdata="tab.clinicChartdata" :options="tab.options"></doughnut-chart>
          <doughnut-chart class="shift-pills" v-show="view === 'compound'" :chartdata="tab.compoundChartdata" :options="tab.options"></doughnut-chart>
          <div id="followup-label">
            <h1 class="tw-text-4xl tw-font-bolder text-center tw-mb-0">{{ getPercent }}%</h1>
            <h5 class="tw-font-bolder text-center">Complete</h5>
          </div>

          <div class="text-right">
            <b-button :to="{name: 'metrics-subject-followup'}" variant="outline-secondary">More</b-button>
          </div>
        </b-tab>
      </b-tabs>

      <div class="tw-mt-auto tw-flex tw-justify-end">
        <info-popover>
          <template v-slot:title>
            Followups Completed on Time
          </template>

          For both Clinic and Compound, and combined, graph the counts of Complete, Incomplete and Missed followups.
        </info-popover>
      </div>

    </b-card>
  </div>
</template>

<script>
import { HTTP } from "@/utilities/http-common";
import HandleErrors from "@/utilities/handle-errors";

// import {
//     mapState, mapGetters, mapActions
// } from 'vuex';

import DoughnutChart from "@/components/charts/DoughnutChart.vue";

import * as _ from 'lodash';

export default {
  mixins: [],
  components: {
    DoughnutChart
  },
  props: {},
  data: function() {
    return {
      ready: false,
      tabIndex: 0,
      tabs: {},
      data: {},
      percent: 0,
      defaultSelected: "Cohort 2",
      view: "total",
      totalChartdata: {
        datasets: [],
        labels: ["Complete", "Incomplete", "Missed"]
      },
      compoundChartdata: {
        // datasets: [
        //   {
        //     data: [],
        //     backgroundColor: ["#37B1CA", "#a3d2e0", "#d9eaef"]
        //   }
        // ],
        datasets: [],
        labels: ["Complete", "Missed"]
      },
      clinicChartdata: {
        datasets: [],
        labels: ["Complete", "Missed"]
      },
      options: {
        responsive: true,
        maintainAspectRatio: true,
        cutoutPercentage: 65,
        circumference: Math.PI,
        rotation: -Math.PI,
        legend: {
          position: "bottom",
          labels: {
            boxWidth: 18
          }
        },
        title: {
          display: false,
          text: "Enrolled Subjects"
        },
        tooltips: {
          bodyFontSize: 14
        },
        animation: {
          animateScale: true,
          animateRotate: true
        }
      }
    };
  },
  computed: {
      getPercent() {
        let that = this;
        let studyPhases = ['Baseline', 'Cohort 1', 'Cohort 2']
        let studyPhase = studyPhases[that.tabIndex];
        let complete = that.data[studyPhase][that.view][0];
        let denominator = 0

        _.each(that.data[studyPhase][this.view], (val) => {
            denominator += val;
        });

        let percent = (complete / denominator) * 100;

        return (_.isNaN(percent)) ? 0 : Math.round(percent);
      }
  },
  created: function() {},
  mounted: function() {
    this.get();
  },
  methods: {
    get: function() {
      const that = this;
      HTTP.get("/kenya/metrics/followups-completed")
        .then(response => {
          that.ready = false;

            _.each(response.data, (val, key) => {
                that.data[key] = response.data[key];

                that.tabs[key] = {
                    id: key.replace(' ', '-'),
                    totalChartdata: _.cloneDeep(that.totalChartdata),
                    compoundChartdata: _.cloneDeep(that.compoundChartdata),
                    clinicChartdata: _.cloneDeep(that.clinicChartdata),
                    options: _.cloneDeep(that.options)
                };

                that.tabs[key].totalChartdata.datasets.push({
                    data: that.data[key]['total'],
                    backgroundColor: ["#37B1CA", "orange", "#d9eaef"]
                });
                that.tabs[key].clinicChartdata.datasets.push({
                    data: that.data[key]['clinic'],
                    backgroundColor: ["#37B1CA", "#d9eaef"]
                });
                that.tabs[key].compoundChartdata.datasets.push({
                    data: that.data[key]['compound'],
                    backgroundColor: ["#37B1CA", "#d9eaef"]
                });
            });

            that.ready = true;
        })
        .catch(error => {
          HandleErrors.HandleErrors(error);
        });
    },
    find: function() {},
    create: function() {},
    patch: function() {},
    update: function() {},
    delete: function() {}
  }
};
</script>

<style>
#followup-label {
  position: absolute;
  top: 70%;
  left: 50%;
  transform: translate(-50%, -50%);
}
nav.card-header {
  border-bottom: none;
  padding: 0.5rem 0 0 0;
}
ul.nav.nav-tabs {
  padding: 0 .5rem;
}
ul.nav.nav-tabs li.nav-item {
  font-size: 0.7rem;
}
ul.nav.nav-tabs a.nav-link {
  padding: .35rem .5rem;
}
ul.nav.nav-pills {
  margin-top: 25px;
}
ul.nav.nav-pills a.nav-link {
  color: #18487c;
  padding: .25rem .5rem;
}
ul.nav.nav-pills a.nav-link.active {
  color: #fff;
  background-color: #18487c;
}
.shift-pills {
  margin-top: -42px;
}

@media all and (min-width: 1000px) {
  #followup-label {
    top: 70%;
  }
}

@media all and (min-width: 1100px) {
  #followup-label {
    top: 50%;
  }
}

@media all and (min-width: 1600px) {
  #followup-label {
    top: 67%;
  }
}
</style>